/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { customerPermissionsPageDataResource } from '@jira/router-resources__service-desk-customer-permissions/src/customerPermissionsPageDataResource.tsx';
import { projectSettingsServicedeskCustomerPermissionsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskCustomerPermissionsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import ServiceDeskCustomerPermissions, {
	LazyProjectSettingsServiceDeskCustomerPermissions,
} from './ui/service-desk-customer-permissions/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskCustomerPermissionsRouteEntry: Route = createEntry(
	projectSettingsServicedeskCustomerPermissionsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskCustomerPermissions,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			projectContextResource,
			customerPermissionsPageDataResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskCustomerPermissions],

		meta: {
			reporting: {
				id: APP_NAMES.CUSTOMER_PERMISSIONS,
				packageName: toPackageName(APP_NAMES.CUSTOMER_PERMISSIONS),
				teamName: 'jsd-flux-capacitors',
			},
		},

		perfMetricKey: 'jsm-customer-permissions',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
